webpackJsonp([69062039818352],{

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(12);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _stylesModule = __webpack_require__(135);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _SelectArrows = __webpack_require__(85);
	
	var _SelectArrows2 = _interopRequireDefault(_SelectArrows);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _classnames;
	
	  var id = _ref.id,
	      label = _ref.label,
	      options = _ref.options,
	      selectedValue = _ref.selectedValue,
	      value = _ref.value,
	      onChange = _ref.onChange,
	      required = _ref.required;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames3.default)(_stylesModule2.default.container, (_classnames = {}, _classnames[_stylesModule2.default.blankValue] = !(value || selectedValue), _classnames))
	    },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: id },
	      label,
	      required && _react2.default.createElement(
	        'span',
	        { className: _stylesModule2.default.required },
	        '(required)'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'select',
	        {
	          id: id,
	          name: id,
	          value: value || selectedValue,
	          onChange: onChange
	        },
	        options.map(function (_ref2, index) {
	          var text = _ref2.text,
	              optionValue = _ref2.value;
	          return _react2.default.createElement(
	            'option',
	            { key: index, value: optionValue },
	            text
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.arrowContainer },
	        _react2.default.createElement(_SelectArrows2.default, { size: 16 })
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-drop-down----styles-module---container---yOxcw","blankValue":"src-components-contribution-form-form-components-drop-down----styles-module---blankValue---1c04v","arrowContainer":"src-components-contribution-form-form-components-drop-down----styles-module---arrowContainer---27oz_","required":"src-components-contribution-form-form-components-drop-down----styles-module---required---2xSA-"};

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(136);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	var _emailNotice = __webpack_require__(160);
	
	var _emailNotice2 = _interopRequireDefault(_emailNotice);
	
	var _Checkbox = __webpack_require__(159);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailInput = function (_Component) {
	  _inherits(EmailInput, _Component);
	
	  function EmailInput() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EmailInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      emailSaved: false
	    }, _this.setEmailValue = function (event) {
	      _this.props.setEmailValue(event);
	      if (_this.state.emailSaved) {
	        window.localStorage.setItem('saved-email', _this.props.emailValue);
	      }
	    }, _this.toggleSaveChoice = function (event) {
	      if (_this.state.emailSaved) {
	        // Disabling so clear stored value
	        console.log('clearing');
	        window.localStorage.setItem('saved-email', '');
	      } else {
	        console.log('saving', _this.props.emailValue);
	        window.localStorage.setItem('saved-email', _this.props.emailValue);
	      }
	
	      _this.setState(function (state) {
	        return { emailSaved: !state.emailSaved };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  EmailInput.prototype.componentDidMount = function componentDidMount() {
	    var foundEmail = window.localStorage.getItem('saved-email');
	
	    if (foundEmail) {
	      this.setState({ emailSaved: true });
	      this.props.setEmailValue({ target: { value: foundEmail } });
	    }
	  };
	
	  EmailInput.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_textBox2.default, {
	        required: true,
	        type: 'email',
	        id: _text2.default.FORMS.emailId,
	        label: _text2.default.FORMS.emailLabel,
	        placeholder: _text2.default.FORMS.emailPlaceholder,
	        value: this.props.emailValue,
	        onChange: this.setEmailValue
	      }),
	      _react2.default.createElement(
	        'label',
	        {
	          className: _stylesModule2.default.checkboxLabel,
	          htmlFor: 'save-email',
	          onClick: function onClick(event) {
	            event.preventDefault();
	            _this2.toggleSaveChoice(event);
	          }
	        },
	        _react2.default.createElement(_Checkbox2.default, {
	          borderStyle: true,
	          color: '#fff',
	          type: 'checkbox',
	          id: 'save-email',
	          value: this.state.emailSaved,
	          onChange: this.toggleSaveChoice
	        }),
	        _react2.default.createElement(
	          'span',
	          null,
	          'Remember email address'
	        )
	      ),
	      _react2.default.createElement(_emailNotice2.default, null)
	    );
	  };
	
	  return EmailInput;
	}(_react.Component);
	
	exports.default = EmailInput;
	module.exports = exports['default'];

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"checkboxLabel":"src-components-contribution-form-form-components-email-input----styles-module---checkboxLabel---2W0Zo"};

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(137);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Warning = __webpack_require__(128);
	
	var _Warning2 = _interopRequireDefault(_Warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var title = _ref.title,
	      message = _ref.message;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(_Warning2.default, { color: '#AD343E', size: null }),
	    _react2.default.createElement(
	      'div',
	      null,
	      title && _react2.default.createElement(
	        'h3',
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        message
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-error-message----styles-module---container---3FWZ3"};

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(138);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _Tooltip = __webpack_require__(60);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var submitText = _ref.submitText,
	      submitOnClick = _ref.submitOnClick,
	      submitDisabled = _ref.submitDisabled,
	      submitDisabledMessage = _ref.submitDisabledMessage,
	      cancelText = _ref.cancelText,
	      cancelOnClick = _ref.cancelOnClick;
	
	  var submitButton = _react2.default.createElement(_pillButton2.default, {
	    id: 'submit-form',
	    type: 'submit',
	    preventDefault: true,
	    text: submitText,
	    onClick: submitOnClick,
	    disabled: submitDisabled
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    submitDisabled ? _react2.default.createElement(
	      _Tooltip2.default,
	      { above: true, error: true, text: submitDisabledMessage },
	      submitButton
	    ) : submitButton,
	    _react2.default.createElement(_pillButton2.default, {
	      preventDefault: true,
	      theme: 'grey-ghost',
	      text: cancelText,
	      onClick: cancelOnClick
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-form-buttons----styles-module---container---1atrA"};

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _formValidator = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function capsFirst(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	var arrayFields = ['images', 'relatedItems'];
	
	var FormController = function (_Component) {
	  _inherits(FormController, _Component);
	
	  function FormController(props, fieldNames, requiredFields, pages) {
	    _classCallCheck(this, FormController);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.updateValue = function (property, value) {
	      _this.setState(function (state) {
	        var _ref;
	
	        return _ref = {}, _ref[property] = value, _ref;
	      });
	      _this.setState(function (state) {
	        return { formValid: _this.validate(state) };
	      });
	    };
	
	    _this.validate = function (state) {
	      return (0, _formValidator.validateFields)(_this.requiredFields, state);
	    };
	
	    _this.validationMessage = function () {
	      return (0, _formValidator.getValidationMessage)(_this.requiredFields, _this.state);
	    };
	
	    _this.extractFields = function () {
	      // Fields are all text inputs indicated by ending in the word "Value"
	      var fields = Object.keys(_this.state).filter(function (key) {
	        return key.endsWith('Value');
	      }).reduce(function (result, key) {
	        var _extends2;
	
	        return _extends(result, (_extends2 = {}, _extends2[key.replace('Value', '')] = _this.state[key], _extends2));
	      }, {});
	
	      if (_this.fieldNames.includes('relatedItems')) {
	        fields.relatedItems = _this.state.relatedItems.join(',');
	      }
	
	      return fields;
	    };
	
	    _this.submit = function () {
	      _this.props.submitForm({ fields: _this.extractFields(), images: _this.state.images }, _this.state);
	    };
	
	    _this.getFooterProps = function (submitOverride, submitDisabled, submitDisabledMessage) {
	      var firstPage = _this.state.stage === 1;
	      var lastPage = _this.state.stage === _this.pages;
	
	      return {
	        submitText: lastPage ? _text2.default.COMMON_LABELS.submitText : _text2.default.COMMON_LABELS.nextText,
	        submitOnClick: lastPage ? submitOverride || _this.submit : _this.nextPage,
	        submitDisabled: lastPage && (submitDisabled !== undefined ? submitDisabled : !_this.state.formValid),
	        submitDisabledMessage: lastPage && (submitDisabledMessage !== undefined ? submitDisabledMessage : _this.validationMessage(_this.state)),
	        cancelText: firstPage ? _text2.default.COMMON_LABELS.cancelText : _text2.default.COMMON_LABELS.backText,
	        cancelOnClick: firstPage ? _this.props.closeForm : _this.backPage
	      };
	    };
	
	    _this.nextPage = function () {
	      return _this.setState(function (state) {
	        return { stage: state.stage + 1 };
	      });
	    };
	
	    _this.backPage = function () {
	      return _this.setState(function (state) {
	        return { stage: state.stage - 1 };
	      });
	    };
	
	    _this.pages = pages;
	    // Store field name config
	    _this.fieldNames = fieldNames;
	
	    if (!requiredFields) {
	      _this.requiredFields = fieldNames;
	    } else {
	      _this.requiredFields = requiredFields;
	    }
	
	    // Set state
	    if (props.recoveryState) {
	      _this.state = props.recoveryState;
	    } else {
	      _this.state = _extends({
	        // Form defaults to invalid
	        formValid: false,
	
	        stage: 1
	
	      }, fieldNames.reduce(function (result, fieldName) {
	        var _extends3, _extends4;
	
	        return (
	          // The images field is an array not a string
	          arrayFields.includes(fieldName) ? _extends(result, (_extends3 = {}, _extends3[fieldName] = [], _extends3)) : _extends(result, (_extends4 = {}, _extends4[fieldName] = '', _extends4))
	        );
	      }, {}));
	    }
	
	    // Create field update listeners
	    fieldNames.forEach(function (fieldName) {
	      _this['set' + capsFirst(fieldName)] = arrayFields.includes(fieldName) ? function (images) {
	        return _this.updateValue(fieldName, images);
	      } : function (event) {
	        return _this.updateValue(fieldName, event.target.value);
	      };
	    });
	    return _this;
	  }
	
	  return FormController;
	}(_react.Component);
	
	exports.default = FormController;
	module.exports = exports['default'];

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stylesModule = __webpack_require__(139);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      nested = _ref.nested;
	  return _react2.default.createElement(
	    'form',
	    { className: (0, _classnames2.default)(_stylesModule2.default.container, nested && _stylesModule2.default.nested) },
	    children
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-form-wrapper----styles-module---container---2aOqt","nested":"src-components-contribution-form-form-components-form-wrapper----styles-module---nested---2Ivgv"};

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(140);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _Tooltip = __webpack_require__(60);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _square = __webpack_require__(56);
	
	var _square2 = _interopRequireDefault(_square);
	
	var _Cross = __webpack_require__(28);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	var _TickOutline = __webpack_require__(163);
	
	var _TickOutline2 = _interopRequireDefault(_TickOutline);
	
	var _Tick = __webpack_require__(62);
	
	var _Tick2 = _interopRequireDefault(_Tick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageTile = function ImageTile(_ref) {
	  var image = _ref.image,
	      isMain = _ref.isMain,
	      mainDisabled = _ref.mainDisabled,
	      setMainClick = _ref.setMainClick,
	      removeClick = _ref.removeClick;
	
	  var mainButton = _react2.default.createElement(
	    'button',
	    {
	      type: 'button',
	      disabled: mainDisabled,
	      className: isMain ? _stylesModule2.default.mainSelected : null,
	      onClick: setMainClick
	    },
	    isMain ? _react2.default.createElement(_Tick2.default, { size: 14, color: '#3e5c76' }) : _react2.default.createElement(_TickOutline2.default, { size: 14, color: '#fff' }),
	    _react2.default.createElement(
	      'span',
	      null,
	      'Main'
	    )
	  );
	
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.imagePreview },
	    _react2.default.createElement(
	      _square2.default,
	      null,
	      image.data ? _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.imageContainer },
	        _react2.default.createElement('img', { src: image.data })
	      ) : _react2.default.createElement(
	        'p',
	        null,
	        'Loading image'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.nameAndButton },
	      _react2.default.createElement(
	        'p',
	        { title: image.name },
	        image.name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.actions },
	        mainDisabled ? _react2.default.createElement(
	          _Tooltip2.default,
	          { inline: true, text: 'Item must have one main image' },
	          mainButton
	        ) : mainButton,
	        _react2.default.createElement(
	          'button',
	          { onClick: removeClick },
	          _react2.default.createElement(_Cross2.default, { size: 14, color: '#fff' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Remove'
	          )
	        )
	      )
	    )
	  );
	};
	
	var ImageSelection = function (_Component) {
	  _inherits(ImageSelection, _Component);
	
	  function ImageSelection() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ImageSelection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.fileSelected = function (event) {
	      var file = event.target.files[0];
	      var reader = new FileReader();
	
	      reader.onloadend = function () {
	        var newArray = [].concat(_this.props.images, [{
	          name: file.name,
	          loading: false,
	          data: reader.result,
	          blob: file
	        }]);
	        _this.props.onChange(newArray);
	      };
	
	      reader.readAsDataURL(file);
	    }, _this.removeImage = function (index) {
	      var newArray = [].concat(_this.props.images);
	      newArray.splice(index, 1);
	      _this.props.onChange(newArray, index === _this.props.mainImageValue, index);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ImageSelection.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.container },
	      _react2.default.createElement('input', {
	        type: 'file',
	        id: _text2.default.FORMS.imagesId,
	        onChange: this.fileSelected,
	        accept: 'image/x-png,image/gif,image/jpeg',
	        value: ''
	      }),
	      _react2.default.createElement(_pillButton2.default, {
	        tag: 'label',
	        theme: 'blue',
	        htmlFor: _text2.default.FORMS.imagesId,
	        text: _text2.default.FORMS.imagesLabel
	      }),
	      _react2.default.createElement(
	        'p',
	        { className: _stylesModule2.default.amountSelectedLabel },
	        this.props.images.length === 0 ? _text2.default.FORMS.imageNoneSelected : _text2.default.FORMS.imagesXSelected.replace('{x}', this.props.images.length).replace('(s)', this.props.images.length > 1 ? 's' : '')
	      ),
	      this.props.images.length > 0 && _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.previews },
	        this.props.images.map(function (image, index) {
	          return _react2.default.createElement(ImageTile, {
	            key: image.name + '-' + index,
	            image: image,
	            isMain: _this2.props.mainImageValue === index,
	            mainDisabled: _this2.props.requiresMain && _this2.props.mainImageValue === index,
	            setMainClick: function setMainClick(event) {
	              return _this2.props.setMainImageValue({
	                target: {
	                  value: _this2.props.mainImageValue === index ? null : index
	                }
	              });
	            },
	            removeClick: function removeClick() {
	              return _this2.removeImage(index);
	            }
	          });
	        }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Select an image as the "main" image for an item and it will be the image shown in search results and the first image shown of the items page.'
	        )
	      )
	    );
	  };
	
	  return ImageSelection;
	}(_react.Component);
	
	exports.default = ImageSelection;
	module.exports = exports['default'];

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-image-selection----styles-module---container---2Uu6L","amountSelectedLabel":"src-components-contribution-form-form-components-image-selection----styles-module---amountSelectedLabel---8-A_q","previews":"src-components-contribution-form-form-components-image-selection----styles-module---previews---3EmhR","imagePreview":"src-components-contribution-form-form-components-image-selection----styles-module---imagePreview---28IdE","imageContainer":"src-components-contribution-form-form-components-image-selection----styles-module---imageContainer---15Jbg","nameAndButton":"src-components-contribution-form-form-components-image-selection----styles-module---nameAndButton---2UWNn","actions":"src-components-contribution-form-form-components-image-selection----styles-module---actions---3PFrf","mainSelected":"src-components-contribution-form-form-components-image-selection----styles-module---mainSelected---7IbUr"};

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(141);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _stageProgress = __webpack_require__(61);
	
	var _stageProgress2 = _interopRequireDefault(_stageProgress);
	
	var _formButtons = __webpack_require__(101);
	
	var _formButtons2 = _interopRequireDefault(_formButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var title = _ref.title,
	      subTitle = _ref.subTitle,
	      stages = _ref.stages,
	      children = _ref.children,
	      footerProps = _ref.footerProps;
	  return _react2.default.createElement(
	    'div',
	    { id: 'form-overlay', className: _stylesModule2.default.container },
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.header },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.inner },
	        _react2.default.createElement(
	          'h2',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          subTitle
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.middle },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.inner },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.split },
	          stages && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.steps },
	            _react2.default.createElement(_stageProgress2.default, { stages: stages })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.form },
	            children
	          )
	        )
	      )
	    ),
	    footerProps && _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.footer },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.inner },
	        _react2.default.createElement(_formButtons2.default, footerProps)
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---container---2NVvT","header":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---header---3Ahi2","inner":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---inner---2wzk5","middle":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---middle---1sSz6","split":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---split---1WwYn","steps":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---steps---3ytYU","form":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---form---3iBIf","footer":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---footer---3k1NU"};

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(142);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _glassData = __webpack_require__(24);
	
	var _glassData2 = _interopRequireDefault(_glassData);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _glass = __webpack_require__(129);
	
	var _glass2 = _interopRequireDefault(_glass);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _square = __webpack_require__(56);
	
	var _square2 = _interopRequireDefault(_square);
	
	var _Plus = __webpack_require__(126);
	
	var _Plus2 = _interopRequireDefault(_Plus);
	
	var _Cross = __webpack_require__(28);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectedItem = function SelectedItem(_ref) {
	  var id = _ref.id,
	      _onClick = _ref.onClick,
	      noRemove = _ref.noRemove;
	  return _react2.default.createElement(
	    'button',
	    {
	      className: _stylesModule2.default.selectedItem,
	      onClick: function onClick(event) {
	        event.preventDefault();
	        _onClick();
	      }
	    },
	    _react2.default.createElement(
	      'span',
	      null,
	      _glassData2.default.find(function (item) {
	        return item.id === id;
	      }).title
	    ),
	    !noRemove && _react2.default.createElement(_Cross2.default, { color: 'white' })
	  );
	};
	
	var ResultItem = function ResultItem(_ref2) {
	  var title = _ref2.title,
	      _onClick2 = _ref2.onClick;
	  return _react2.default.createElement(
	    'button',
	    {
	      className: _stylesModule2.default.resultItem,
	      onClick: function onClick(event) {
	        event.preventDefault();
	        _onClick2();
	      }
	    },
	    _react2.default.createElement(
	      'span',
	      null,
	      title
	    ),
	    _react2.default.createElement(_Plus2.default, { size: 12, color: 'white' })
	  );
	};
	
	var searchGlass = function searchGlass(items, searchTerm, alreadySelected) {
	  return (0, _glass2.default)(items, searchTerm).filter(function (item) {
	    return !alreadySelected.includes(item.id);
	  }).slice(0, 8);
	};
	
	var RelatedItemSelection = function (_Component) {
	  _inherits(RelatedItemSelection, _Component);
	
	  function RelatedItemSelection(props) {
	    _classCallCheck(this, RelatedItemSelection);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.setSearchTerm = function (event) {
	      return _this.setState({
	        searchTerm: event.target.value,
	        searchResults: searchGlass(_glassData2.default, event.target.value, _this.props.selectedItems)
	      });
	    };
	
	    _this.selectItem = function (id) {
	      var newSelectedItems = [].concat(_this.props.selectedItems, [id]);
	      _this.props.onChange(newSelectedItems);
	      _this.setState(function (state) {
	        return {
	          searchResults: searchGlass(_glassData2.default, state.searchTerm, newSelectedItems)
	        };
	      });
	    };
	
	    _this.deselectItem = function (id) {
	      var newSelectedItems = _this.props.selectedItems.filter(function (value) {
	        return value !== id;
	      });
	      _this.props.onChange(newSelectedItems);
	      _this.setState(function (state) {
	        return {
	          searchResults: searchGlass(_glassData2.default, state.searchTerm, newSelectedItems)
	        };
	      });
	    };
	
	    _this.state = {
	      searchTerm: '',
	      searchResults: searchGlass(_glassData2.default, '', [props.preselectedItemId])
	    };
	    return _this;
	  }
	
	  RelatedItemSelection.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        null,
	        this.props.form === 'memory' ? _text2.default.FORMS.releatedItemsMemoryDescription : _text2.default.FORMS.releatedItemsItemDescription
	      ),
	      this.props.selectedItems.length === 0 ? _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.noneSelected },
	        'No items selected. Search for some below.'
	      ) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          { className: _stylesModule2.default.selected },
	          this.props.selectedItems.map(function (id) {
	            return _react2.default.createElement(
	              'li',
	              { key: id },
	              _react2.default.createElement(SelectedItem, {
	                id: id,
	                onClick: function onClick() {
	                  return _this2.deselectItem(id);
	                },
	                noRemove: id === _this2.props.preselectedItemId
	              })
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.searchAndSelect },
	        _react2.default.createElement(_textBox2.default, {
	          id: 'itemSearch',
	          label: 'Search items',
	          placeholder: 'Search for items by name...',
	          value: this.state.searchTerm,
	          onChange: this.setSearchTerm
	        }),
	        this.state.searchResults.length === 0 || !this.state.searchTerm ? _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.noResults },
	          !this.state.searchTerm ? 'Enter a search term to see items to select.' : 'No items found matching that search term.'
	        ) : _react2.default.createElement(
	          'ul',
	          { className: _stylesModule2.default.results },
	          this.state.searchResults.map(function (_ref3) {
	            var id = _ref3.id,
	                title = _ref3.title;
	            return _react2.default.createElement(
	              'li',
	              { key: id },
	              _react2.default.createElement(ResultItem, {
	                title: title,
	                onClick: function onClick() {
	                  return _this2.selectItem(id);
	                }
	              })
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return RelatedItemSelection;
	}(_react.Component);
	
	exports.default = RelatedItemSelection;
	module.exports = exports['default'];

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-related-items-selection----styles-module---container---pZR7_","noneSelected":"src-components-contribution-form-form-components-related-items-selection----styles-module---noneSelected---2MbXF","noResults":"src-components-contribution-form-form-components-related-items-selection----styles-module---noResults---2DRtn","searchAndSelect":"src-components-contribution-form-form-components-related-items-selection----styles-module---searchAndSelect---1OLpJ","selected":"src-components-contribution-form-form-components-related-items-selection----styles-module---selected---2ZXLe","results":"src-components-contribution-form-form-components-related-items-selection----styles-module---results---Tim2s","selectedItem":"src-components-contribution-form-form-components-related-items-selection----styles-module---selectedItem---3wEoC","resultItem":"src-components-contribution-form-form-components-related-items-selection----styles-module---resultItem---1d8Jz"};

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(143);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var stages = _ref.stages;
	  return _react2.default.createElement(
	    'nav',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.title },
	      'Steps'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      stages.map(function (_ref2, index) {
	        var name = _ref2.name,
	            active = _ref2.active,
	            disabled = _ref2.disabled,
	            _onClick = _ref2.onClick;
	        return _react2.default.createElement(
	          'li',
	          { key: name },
	          _react2.default.createElement(
	            'button',
	            {
	              id: 'form-step-' + (index + 1),
	              className: active ? _stylesModule2.default.active : undefined,
	              disabled: disabled,
	              onClick: function onClick(event) {
	                event.preventDefault();
	                _onClick();
	              }
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              index + 1
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              name
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-stage-progress----styles-module---container---30UkT","title":"src-components-contribution-form-form-components-stage-progress----styles-module---title---2M6fy","active":"src-components-contribution-form-form-components-stage-progress----styles-module---active---3qi1C"};

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glassData = __webpack_require__(24);
	
	var _glassData2 = _interopRequireDefault(_glassData);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _formController = __webpack_require__(21);
	
	var _formController2 = _interopRequireDefault(_formController);
	
	var _overlayWrapper = __webpack_require__(23);
	
	var _overlayWrapper2 = _interopRequireDefault(_overlayWrapper);
	
	var _formWrapper = __webpack_require__(22);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	var _stageProgress = __webpack_require__(61);
	
	var _stageProgress2 = _interopRequireDefault(_stageProgress);
	
	var _formValidator = __webpack_require__(47);
	
	var _stage = __webpack_require__(103);
	
	var _stage2 = _interopRequireDefault(_stage);
	
	var _stage3 = __webpack_require__(104);
	
	var _stage4 = _interopRequireDefault(_stage3);
	
	var _stage5 = __webpack_require__(105);
	
	var _stage6 = _interopRequireDefault(_stage5);
	
	var _stage7 = __webpack_require__(106);
	
	var _stage8 = _interopRequireDefault(_stage7);
	
	var _stage9 = __webpack_require__(107);
	
	var _stage10 = _interopRequireDefault(_stage9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formStages = {
	  1: _stage2.default,
	  2: _stage4.default,
	  3: _stage6.default,
	  4: _stage8.default,
	  5: _stage10.default
	};
	
	var EditItemForm = function (_FormController) {
	  _inherits(EditItemForm, _FormController);
	
	  function EditItemForm(props) {
	    _classCallCheck(this, EditItemForm);
	
	    var _this = _possibleConstructorReturn(this, _FormController.call(this, props, [
	    // Stage One
	    'itemNameValue', 'itemDescValue',
	
	    // Stage Two
	    'locationValue', 'yearValue', 'designerValue', 'productionMethodValue', 'productionLocationValue', 'tablewareTypeValue', 'patternNumberValue', 'colorValue',
	
	    // Stage Three
	    'mainImageValue', 'images',
	
	    // Stage Four
	    'relatedItems',
	
	    // Stage Five
	    'emailValue'], null, 5));
	
	    _this.moveToStageOne = function () {
	      return _this.setState({ stage: 1 });
	    };
	
	    _this.moveToStageTwo = function () {
	      return _this.setState({ stage: 2 });
	    };
	
	    _this.moveToStageThree = function () {
	      return _this.setState({ stage: 3 });
	    };
	
	    _this.moveToStageFour = function () {
	      return _this.setState({ stage: 4 });
	    };
	
	    _this.editFormValid = function () {
	      var fields = _this.extractFields();
	      var item = _glassData2.default.find(function (_ref) {
	        var id = _ref.id;
	        return id === _this.props.itemId;
	      });
	
	      // Check that at least one value has been edited
	      return !!fields.email && (0, _formValidator.validateEmail)(fields.email) && !!fields.itemName && (fields.itemName !== item.title || fields.itemDesc !== item.description || fields.location !== item.data.location || fields.year !== item.data.year || fields.designer !== item.data.designer || fields.productionMethod !== item.data.productionMethod || fields.productionLocation !== item.data.productionLocation || fields.tablewareType !== item.data.tablewareType || fields.patternNumber !== item.data.patternNumber || fields.color !== item.data.colour || fields.relatedItems !== item.relatedItems.join(',') || fields.mainImage !== null && fields.mainImage !== '' || _this.state.images.length > 0);
	    };
	
	    _this.editFormValidationMessage = function () {
	      var fields = _this.extractFields();
	
	      if (!fields.email) {
	        return 'Please enter your email address';
	      } else if (!(0, _formValidator.validateEmail)(fields.email)) {
	        return _text2.default.FORMS.invalidEmailAddress;
	      } else if (!fields.itemName) {
	        return 'You must provide an item name';
	      } else if (!_this.editFormValid()) {
	        return 'You have not changed any values';
	      }
	    };
	
	    _this.handleSetImages = function (images, removedMain, removedIndex) {
	      if (removedMain) {
	        if (!_this.hasExistingImage) {
	          // If the user just removed the image with was selected as "Main" then set
	          // the first image as Main if the item currently has no images
	          _this.setMainImageValue({ target: { value: 0 } });
	        } else {
	          // If the user just removed the image with was selected as "Main" then set
	          // the value as null if the item currently has some images
	          _this.setMainImageValue({ target: { value: null } });
	        }
	      } else {
	        // If the user just added the first image and the item currently has no
	        // images then make the first image the "Main"
	        if (_this.state.images.length === 0 && images.length === 1 && !_this.hasExistingImage) {
	          _this.setMainImageValue({ target: { value: 0 } });
	        } else {
	          // If the index of the removed image was less than the index of the selected
	          // main then we need to decrement the main index value
	          if (removedIndex < _this.state.mainImageValue) {
	            _this.setMainImageValue({
	              target: { value: _this.state.mainImageValue - 1 }
	            });
	          }
	        }
	      }
	      // Pass up to the actual setImages function
	      _this.setImages(images);
	    };
	
	    _this.submitWrapper = function () {
	      // Only send values which have changed when compared to the original item
	      var item = _glassData2.default.find(function (_ref2) {
	        var id = _ref2.id;
	        return id === _this.props.itemId;
	      });
	
	      // Fields are all text inputs indicated by ending in the word "Value"
	      var fields = _this.extractFields();
	
	      // TODO: Could probably automate these checks if the naming was more consistent
	      if (fields.itemName === item.title) {
	        delete fields.itemName;
	      }
	      if (fields.itemDesc === item.description) {
	        delete fields.itemDesc;
	      }
	      if (fields.location === item.data.location) {
	        delete fields.location;
	      }
	      if (fields.year === item.data.year) {
	        delete fields.year;
	      }
	      if (fields.designer === item.data.designer) {
	        delete fields.designer;
	      }
	      if (fields.productionMethod === item.data.productionMethod) {
	        delete fields.productionMethod;
	      }
	      if (fields.productionLocation === item.data.productionLocation) {
	        delete fields.productionLocation;
	      }
	      if (fields.tablewareType === item.data.tablewareType) {
	        delete fields.tablewareType;
	      }
	      if (fields.patternNumber === item.data.patternNumber) {
	        delete fields.patternNumber;
	      }
	      if (fields.color === item.data.colour) {
	        delete fields.color;
	      }
	      if (fields.relatedItems === item.relatedItems.join(',')) {
	        delete fields.relatedItems;
	      }
	      if (!fields.mainImage) {
	        delete fields.mainImage;
	      }
	
	      _this.props.submitForm({ fields: fields, images: _this.state.images }, _this.state);
	    };
	
	    _extends(_this.state, {
	      stage: _this.state.stage || 1
	    });
	
	    _this.hasExistingImage = !!_glassData2.default.find(function (_ref3) {
	      var id = _ref3.id;
	      return id === props.itemId;
	    }).mainImage;
	
	    if (!props.recoveryState) {
	      // Load details of item to fill form values
	      var item = _glassData2.default.find(function (_ref4) {
	        var id = _ref4.id;
	        return id === props.itemId;
	      });
	      _this.itemType = item.data.glassType;
	
	      // Stage One
	      _this.state.itemNameValue = item.title;
	      _this.state.itemDescValue = item.description;
	
	      // Stage Two
	      _this.state.locationValue = item.data.location;
	      _this.state.yearValue = item.data.year;
	      _this.state.designerValue = item.data.designer;
	      _this.state.productionMethodValue = item.data.productionMethod;
	      _this.state.productionLocationValue = item.data.productionLocation;
	
	      _this.state.tablewareTypeValue = item.data.tablewareType;
	      _this.state.patternNumberValue = item.data.patternNumber;
	      _this.state.colorValue = item.data.colour;
	
	      // Stage Three
	      //  - Existing images not yet loaded
	
	      // Stage Four
	      _this.state.relatedItems = item.relatedItems;
	    }
	    return _this;
	  }
	
	  EditItemForm.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _overlayWrapper2.default,
	      {
	        title: _text2.default.CONTRIBUTION_FORMS.EDIT_ITEM.title,
	        subTitle: _text2.default.CONTRIBUTION_FORMS.EDIT_ITEM.subTitle,
	        footerProps: this.getFooterProps(this.submitWrapper, !this.editFormValid(), this.editFormValidationMessage()),
	        stages: [{
	          name: 'Description',
	          active: this.state.stage === 1,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 1 });
	          }
	        }, {
	          name: 'Details',
	          active: this.state.stage === 2,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 2 });
	          }
	        }, {
	          name: 'Images',
	          active: this.state.stage === 3,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 3 });
	          }
	        }, {
	          name: 'Related',
	          active: this.state.stage === 4,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 4 });
	          }
	        }, {
	          name: 'Finish',
	          active: this.state.stage === 5,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 5 });
	          }
	        }]
	      },
	      _react2.default.createElement(
	        _formWrapper2.default,
	        { nested: true },
	        _react2.default.createElement(formStages[this.state.stage], {
	          // Stage One values
	          itemNameValue: this.state.itemNameValue,
	          setItemNameValue: this.setItemNameValue,
	          itemTypeValue: this.itemType,
	          itemDescValue: this.state.itemDescValue,
	          setItemDescValue: this.setItemDescValue,
	
	          // Stage Two values
	          locationValue: this.state.locationValue,
	          setLocationValue: this.setLocationValue,
	          yearValue: this.state.yearValue,
	          setYearValue: this.setYearValue,
	          productionMethodValue: this.state.productionMethodValue,
	          setProductionMethodValue: this.setProductionMethodValue,
	          productionLocationValue: this.state.productionLocationValue,
	          setProductionLocationValue: this.setProductionLocationValue,
	          tablewareTypeValue: this.state.tablewareTypeValue,
	          setTablewareTypeValue: this.setTablewareTypeValue,
	          patternNumberValue: this.state.patternNumberValue,
	          setPatternNumberValue: this.setPatternNumberValue,
	          colorValue: this.state.colorValue,
	          setColorValue: this.setColorValue,
	          designerValue: this.state.designerValue,
	          setDesignerValue: this.setDesignerValue,
	
	          // Stage Three values
	          images: this.state.images,
	          setImages: this.handleSetImages,
	          requiresMainImage: !this.hasExistingImage,
	          mainImageValue: this.state.mainImageValue,
	          setMainImageValue: this.setMainImageValue,
	
	          // Stage Four values
	          relatedItems: this.state.relatedItems,
	          setRelatedItems: this.setRelatedItems,
	
	          // Stage Five
	          emailValue: this.state.emailValue,
	          setEmailValue: this.setEmailValue,
	          formValid: this.editFormValid(),
	          validationMessage: this.editFormValidationMessage()
	        })
	      )
	    );
	  };
	
	  return EditItemForm;
	}(_formController2.default);
	
	exports.default = EditItemForm;
	module.exports = exports['default'];

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	var _textArea = __webpack_require__(27);
	
	var _textArea2 = _interopRequireDefault(_textArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var itemNameValue = _ref.itemNameValue,
	      setItemNameValue = _ref.setItemNameValue,
	      itemDescValue = _ref.itemDescValue,
	      setItemDescValue = _ref.setItemDescValue;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_textBox2.default, {
	      required: true,
	      id: _text2.default.FORMS.itemNameId,
	      label: _text2.default.FORMS.itemNameLabel,
	      placeholder: _text2.default.FORMS.itemNamePlaceholder,
	      value: itemNameValue,
	      onChange: setItemNameValue
	    }),
	    _react2.default.createElement(_textArea2.default, {
	      id: _text2.default.FORMS.itemDescId,
	      label: _text2.default.FORMS.itemDescLabel,
	      placeholder: _text2.default.FORMS.itemDescPlaceholder,
	      value: itemDescValue,
	      onChange: setItemDescValue
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	var _dropDown = __webpack_require__(26);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var itemTypeValue = _ref.itemTypeValue,
	      locationValue = _ref.locationValue,
	      setLocationValue = _ref.setLocationValue,
	      yearValue = _ref.yearValue,
	      setYearValue = _ref.setYearValue,
	      designerValue = _ref.designerValue,
	      setDesignerValue = _ref.setDesignerValue,
	      productionMethodValue = _ref.productionMethodValue,
	      setProductionMethodValue = _ref.setProductionMethodValue,
	      productionLocationValue = _ref.productionLocationValue,
	      setProductionLocationValue = _ref.setProductionLocationValue,
	      tablewareTypeValue = _ref.tablewareTypeValue,
	      setTablewareTypeValue = _ref.setTablewareTypeValue,
	      patternNumberValue = _ref.patternNumberValue,
	      setPatternNumberValue = _ref.setPatternNumberValue,
	      colorValue = _ref.colorValue,
	      setColorValue = _ref.setColorValue;
	  return _react2.default.createElement(
	    'div',
	    null,
	    itemTypeValue === 'WINDOW' && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.locationId,
	        label: _text2.default.FORMS.locationLabel,
	        placeholder: _text2.default.FORMS.locationPlaceholder,
	        value: locationValue,
	        onChange: setLocationValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.yearId,
	        label: _text2.default.FORMS.yearLabel,
	        placeholder: _text2.default.FORMS.yearPlaceholder,
	        value: yearValue,
	        onChange: setYearValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.designerId,
	        label: _text2.default.FORMS.designerLabel,
	        placeholder: _text2.default.FORMS.designerPlaceholder,
	        value: designerValue,
	        onChange: setDesignerValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionMethodId,
	        label: _text2.default.FORMS.productionMethodLabel,
	        options: _text2.default.FORMS.productionMethodWindowOptions,
	        value: productionMethodValue,
	        onChange: setProductionMethodValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionLocationId,
	        label: _text2.default.FORMS.productionLocationLabel,
	        options: _text2.default.FORMS.productionLocationOptions,
	        value: productionLocationValue,
	        onChange: setProductionLocationValue
	      })
	    ),
	    itemTypeValue === 'TABLEWARE' && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.tablewareTypeId,
	        label: _text2.default.FORMS.tablewareTypeLabel,
	        placeholder: _text2.default.FORMS.tablewareTypePlaceholder,
	        value: tablewareTypeValue,
	        onChange: setTablewareTypeValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionMethodId,
	        label: _text2.default.FORMS.productionMethodLabel,
	        options: _text2.default.FORMS.productionMethodTablewareOptions,
	        value: productionMethodValue,
	        onChange: setProductionMethodValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.patternNumberId,
	        label: _text2.default.FORMS.patternNumberLabel,
	        placeholder: _text2.default.FORMS.patternNumberPlaceholder,
	        value: patternNumberValue,
	        onChange: setPatternNumberValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.colorId,
	        label: _text2.default.FORMS.colorLabel,
	        placeholder: _text2.default.FORMS.colorPlaceholder,
	        value: colorValue,
	        onChange: setColorValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.designerId,
	        label: _text2.default.FORMS.designerLabel,
	        placeholder: _text2.default.FORMS.designerPlaceholder,
	        value: designerValue,
	        onChange: setDesignerValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.yearId,
	        label: _text2.default.FORMS.yearLabel,
	        placeholder: _text2.default.FORMS.yearPlaceholder,
	        value: yearValue,
	        onChange: setYearValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionLocationId,
	        label: _text2.default.FORMS.productionLocationLabel,
	        options: _text2.default.FORMS.productionLocationOptions,
	        value: productionLocationValue,
	        onChange: setProductionLocationValue
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imageSelection = __webpack_require__(40);
	
	var _imageSelection2 = _interopRequireDefault(_imageSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var images = _ref.images,
	      setImages = _ref.setImages,
	      requiresMainImage = _ref.requiresMainImage,
	      mainImageValue = _ref.mainImageValue,
	      setMainImageValue = _ref.setMainImageValue;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_imageSelection2.default, {
	      images: images,
	      onChange: setImages,
	      requiresMain: requiresMainImage,
	      setMainImageValue: setMainImageValue,
	      mainImageValue: mainImageValue
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _relatedItemsSelection = __webpack_require__(41);
	
	var _relatedItemsSelection2 = _interopRequireDefault(_relatedItemsSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var relatedItems = _ref.relatedItems,
	      setRelatedItems = _ref.setRelatedItems;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_relatedItemsSelection2.default, {
	      selectedItems: relatedItems,
	      onChange: setRelatedItems
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _emailInput = __webpack_require__(20);
	
	var _emailInput2 = _interopRequireDefault(_emailInput);
	
	var _errorMessage = __webpack_require__(17);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var emailValue = _ref.emailValue,
	      setEmailValue = _ref.setEmailValue,
	      formValid = _ref.formValid,
	      validationMessage = _ref.validationMessage;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_emailInput2.default, { emailValue: emailValue, setEmailValue: setEmailValue }),
	    !formValid && _react2.default.createElement(_errorMessage2.default, {
	      title: 'Form not complete for submission',
	      message: validationMessage
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _formController = __webpack_require__(21);
	
	var _formController2 = _interopRequireDefault(_formController);
	
	var _overlayWrapper = __webpack_require__(23);
	
	var _overlayWrapper2 = _interopRequireDefault(_overlayWrapper);
	
	var _formWrapper = __webpack_require__(22);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	var _textArea = __webpack_require__(27);
	
	var _textArea2 = _interopRequireDefault(_textArea);
	
	var _emailInput = __webpack_require__(20);
	
	var _emailInput2 = _interopRequireDefault(_emailInput);
	
	var _errorMessage = __webpack_require__(17);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GeneralForm = function (_FormController) {
	  _inherits(GeneralForm, _FormController);
	
	  function GeneralForm(props) {
	    _classCallCheck(this, GeneralForm);
	
	    return _possibleConstructorReturn(this, _FormController.call(this, props, ['itemIdValue', 'infoValue', 'emailValue'], ['infoValue', 'emailValue'], 2));
	  }
	
	  GeneralForm.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.itemId && !this.props.recoveryState) {
	      this.setItemIdValue({ target: { value: this.props.itemId } });
	    }
	  };
	
	  GeneralForm.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        closeForm = _props.closeForm,
	        secondaryButtonIsBack = _props.secondaryButtonIsBack,
	        clearForm = _props.clearForm;
	
	    return _react2.default.createElement(
	      _overlayWrapper2.default,
	      {
	        title: _text2.default.CONTRIBUTION_FORMS.GENERAL_INFORMATION.title,
	        subTitle: _text2.default.CONTRIBUTION_FORMS.GENERAL_INFORMATION.subTitle,
	        footerProps: this.getFooterProps(),
	        stages: [{
	          name: 'Details',
	          active: this.state.stage === 1,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 1 });
	          }
	        }, {
	          name: 'Finish',
	          active: this.state.stage === 2,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 2 });
	          }
	        }]
	      },
	      _react2.default.createElement(
	        _formWrapper2.default,
	        null,
	        this.state.stage === 1 && _react2.default.createElement(_textArea2.default, {
	          required: true,
	          id: _text2.default.FORMS.infoId,
	          label: _text2.default.FORMS.infoLabel,
	          placeholder: _text2.default.FORMS.infoPlaceholder,
	          value: this.state.infoValue,
	          onChange: this.setInfoValue
	        }),
	        this.state.stage === 2 && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_emailInput2.default, {
	            emailValue: this.state.emailValue,
	            setEmailValue: this.setEmailValue
	          }),
	          !this.state.formValid && _react2.default.createElement(_errorMessage2.default, {
	            title: 'Form not complete for submission',
	            message: this.validationMessage(this.state)
	          })
	        )
	      )
	    );
	  };
	
	  return GeneralForm;
	}(_formController2.default);
	
	exports.default = GeneralForm;
	module.exports = exports['default'];

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glassData = __webpack_require__(24);
	
	var _glassData2 = _interopRequireDefault(_glassData);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _formController = __webpack_require__(21);
	
	var _formController2 = _interopRequireDefault(_formController);
	
	var _overlayWrapper = __webpack_require__(23);
	
	var _overlayWrapper2 = _interopRequireDefault(_overlayWrapper);
	
	var _formWrapper = __webpack_require__(22);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	var _imageSelection = __webpack_require__(40);
	
	var _imageSelection2 = _interopRequireDefault(_imageSelection);
	
	var _emailInput = __webpack_require__(20);
	
	var _emailInput2 = _interopRequireDefault(_emailInput);
	
	var _errorMessage = __webpack_require__(17);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageForm = function (_FormController) {
	  _inherits(ImageForm, _FormController);
	
	  function ImageForm(props) {
	    _classCallCheck(this, ImageForm);
	
	    var _this = _possibleConstructorReturn(this, _FormController.call(this, props, ['images', 'emailValue', 'mainImageValue'], ['images', 'emailValue'], 2));
	
	    _this.handleSetImages = function (images, removedMain, removedIndex) {
	      if (removedMain) {
	        if (!_this.hasExistingImage) {
	          // If the user just removed the image with was selected as "Main" then set
	          // the first image as Main if the item currently has no images
	          _this.setMainImageValue({ target: { value: 0 } });
	        } else {
	          // If the user just removed the image with was selected as "Main" then set
	          // the value as null if the item currently has some images
	          _this.setMainImageValue({ target: { value: null } });
	        }
	      } else {
	        // If the user just added the first image and the item currently has no
	        // images then make the first image the "Main"
	        if (_this.state.images.length === 0 && images.length === 1 && !_this.hasExistingImage) {
	          _this.setMainImageValue({ target: { value: 0 } });
	        } else {
	          // If the index of the removed image was less than the index of the selected
	          // main then we need to decrement the main index value
	          if (removedIndex < _this.state.mainImageValue) {
	            _this.setMainImageValue({
	              target: { value: _this.state.mainImageValue - 1 }
	            });
	          }
	        }
	      }
	      // Pass up to the actual setImages function
	      _this.setImages(images);
	    };
	
	    _this.hasExistingImage = !!_glassData2.default.find(function (_ref) {
	      var id = _ref.id;
	      return id === props.itemId;
	    }).mainImage;
	    return _this;
	  }
	
	  ImageForm.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        closeForm = _props.closeForm,
	        secondaryButtonIsBack = _props.secondaryButtonIsBack,
	        clearForm = _props.clearForm;
	
	    return _react2.default.createElement(
	      _overlayWrapper2.default,
	      {
	        title: _text2.default.CONTRIBUTION_FORMS.ADD_IMAGES.title,
	        subTitle: _text2.default.CONTRIBUTION_FORMS.ADD_IMAGES.subTitle,
	        footerProps: this.getFooterProps(),
	        stages: [{
	          name: 'New Images',
	          active: this.state.stage === 1,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 1 });
	          }
	        }, {
	          name: 'Review',
	          active: this.state.stage === 2,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 2 });
	          }
	        }]
	      },
	      _react2.default.createElement(
	        _formWrapper2.default,
	        null,
	        this.state.stage === 1 && _react2.default.createElement(_imageSelection2.default, {
	          images: this.state.images,
	          onChange: this.handleSetImages,
	          requiresMain: !this.hasExistingImage,
	          setMainImageValue: this.setMainImageValue,
	          mainImageValue: this.state.mainImageValue
	        }),
	        this.state.stage === 2 && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_emailInput2.default, {
	            emailValue: this.state.emailValue,
	            setEmailValue: this.setEmailValue
	          }),
	          !this.state.formValid && _react2.default.createElement(_errorMessage2.default, {
	            title: 'Form not complete for submission',
	            message: this.validationMessage(this.state)
	          })
	        )
	      )
	    );
	  };
	
	  return ImageForm;
	}(_formController2.default);
	
	exports.default = ImageForm;
	module.exports = exports['default'];

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _formController = __webpack_require__(21);
	
	var _formController2 = _interopRequireDefault(_formController);
	
	var _overlayWrapper = __webpack_require__(23);
	
	var _overlayWrapper2 = _interopRequireDefault(_overlayWrapper);
	
	var _formWrapper = __webpack_require__(22);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	var _textArea = __webpack_require__(27);
	
	var _textArea2 = _interopRequireDefault(_textArea);
	
	var _dropDown = __webpack_require__(26);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _relatedItemsSelection = __webpack_require__(41);
	
	var _relatedItemsSelection2 = _interopRequireDefault(_relatedItemsSelection);
	
	var _emailInput = __webpack_require__(20);
	
	var _emailInput2 = _interopRequireDefault(_emailInput);
	
	var _errorMessage = __webpack_require__(17);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MemoryForm = function (_FormController) {
	  _inherits(MemoryForm, _FormController);
	
	  function MemoryForm(props) {
	    _classCallCheck(this, MemoryForm);
	
	    return _possibleConstructorReturn(this, _FormController.call(this, props, ['nameValue', 'emailValue', 'memoryValue', 'personTypeValue', 'relatedItems'], ['nameValue', 'emailValue', 'memoryValue'], 3));
	  }
	
	  MemoryForm.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.itemId && !this.props.recoveryState) {
	      this.setRelatedItems([this.props.itemId]);
	    }
	  };
	
	  MemoryForm.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _overlayWrapper2.default,
	      {
	        title: _text2.default.CONTRIBUTION_FORMS.ADD_MEMORY.title,
	        subTitle: _text2.default.CONTRIBUTION_FORMS.ADD_MEMORY.subTitle,
	        footerProps: this.getFooterProps(),
	        stages: [{
	          name: 'Memory',
	          active: this.state.stage === 1,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 1 });
	          }
	        }, {
	          name: 'Related Items',
	          active: this.state.stage === 2,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 2 });
	          }
	        }, {
	          name: 'Finish',
	          active: this.state.stage === 3,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 3 });
	          }
	        }]
	      },
	      _react2.default.createElement(
	        _formWrapper2.default,
	        null,
	        this.state.stage === 1 && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_textBox2.default, {
	            required: true,
	            id: _text2.default.FORMS.nameId,
	            label: _text2.default.FORMS.nameLabel,
	            placeholder: _text2.default.FORMS.namePlaceholder,
	            value: this.state.nameValue,
	            onChange: this.setNameValue
	          }),
	          _react2.default.createElement(_dropDown2.default, {
	            id: 'personType',
	            label: 'Your association with Whitefriars',
	            selectedValue: this.state.personTypeValue,
	            onChange: this.setPersonTypeValue,
	            options: [{ text: 'Select your relation to Whitefriars...', value: '' }, { text: 'Staff', value: 'STAFF' }, { text: 'Collectors', value: 'COLLECTOR' }, { text: 'Staff Relatives', value: 'STAFF_RELATIVE' }, { text: 'Other', value: 'OTHER' }]
	          }),
	          _react2.default.createElement(_textArea2.default, {
	            required: true,
	            id: _text2.default.FORMS.memoryId,
	            label: _text2.default.FORMS.memoryLabel,
	            placeholder: _text2.default.FORMS.memoryPlaceholder,
	            value: this.state.memoryValue,
	            onChange: this.setMemoryValue
	          })
	        ),
	        this.state.stage === 2 && _react2.default.createElement(_relatedItemsSelection2.default, {
	          preselectedItemId: this.props.itemId,
	          selectedItems: this.state.relatedItems,
	          onChange: this.setRelatedItems
	        }),
	        this.state.stage === 3 && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_emailInput2.default, {
	            emailValue: this.state.emailValue,
	            setEmailValue: this.setEmailValue
	          }),
	          !this.state.formValid && _react2.default.createElement(_errorMessage2.default, {
	            title: 'Form not complete for submission',
	            message: this.validationMessage(this.state)
	          })
	        )
	      )
	    );
	  };
	
	  return MemoryForm;
	}(_formController2.default);
	
	exports.default = MemoryForm;
	module.exports = exports['default'];

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _formController = __webpack_require__(21);
	
	var _formController2 = _interopRequireDefault(_formController);
	
	var _overlayWrapper = __webpack_require__(23);
	
	var _overlayWrapper2 = _interopRequireDefault(_overlayWrapper);
	
	var _formWrapper = __webpack_require__(22);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	var _formValidator = __webpack_require__(47);
	
	var _stage = __webpack_require__(112);
	
	var _stage2 = _interopRequireDefault(_stage);
	
	var _stage3 = __webpack_require__(113);
	
	var _stage4 = _interopRequireDefault(_stage3);
	
	var _stage5 = __webpack_require__(114);
	
	var _stage6 = _interopRequireDefault(_stage5);
	
	var _stage7 = __webpack_require__(115);
	
	var _stage8 = _interopRequireDefault(_stage7);
	
	var _stage9 = __webpack_require__(116);
	
	var _stage10 = _interopRequireDefault(_stage9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formStages = {
	  1: _stage2.default,
	  2: _stage4.default,
	  3: _stage6.default,
	  4: _stage8.default,
	  5: _stage10.default
	};
	
	var NewItemForm = function (_FormController) {
	  _inherits(NewItemForm, _FormController);
	
	  function NewItemForm(props) {
	    _classCallCheck(this, NewItemForm);
	
	    var _this = _possibleConstructorReturn(this, _FormController.call(this, props, [
	    // Stage One
	    'itemNameValue', 'itemTypeValue', 'itemDescValue', 'emailValue',
	
	    // Stage Two
	    'locationValue', 'yearValue', 'designerValue', 'productionMethodValue', 'productionLocationValue', 'tablewareTypeValue', 'patternNumberValue', 'colorValue',
	
	    // Stage Three
	    'mainImageValue', 'images',
	
	    // Stage Four
	    'relatedItems'], null, 5));
	
	    _this.handleSetImages = function (images, removedMain, removedIndex) {
	      if (removedMain) {
	        // If the user just removed the image with was selected as "Main" then set
	        // the first image as Main if the item currently has no images
	        _this.setMainImageValue({ target: { value: 0 } });
	      } else {
	        // If the user just added the first image and the item currently has no
	        // images then make the first image the "Main"
	        if (_this.state.images.length === 0 && images.length === 1) {
	          _this.setMainImageValue({ target: { value: 0 } });
	        } else {
	          // If the index of the removed image was less than the index of the selected
	          // main then we need to decrement the main index value
	          if (removedIndex < _this.state.mainImageValue) {
	            _this.setMainImageValue({
	              target: { value: _this.state.mainImageValue - 1 }
	            });
	          }
	        }
	      }
	      // Pass up to the actual setImages function
	      _this.setImages(images);
	    };
	
	    _this.newFormValid = function () {
	      var fields = _this.extractFields();
	
	      // Check that at least required fields are input
	      return !!fields.email && (0, _formValidator.validateEmail)(fields.email) && fields.itemName !== '' && fields.itemType !== '';
	    };
	
	    _this.newFormValidationMessage = function () {
	      var fields = _this.extractFields();
	
	      if (!fields.email) {
	        return 'Please enter your email address';
	      } else if (!(0, _formValidator.validateEmail)(fields.email)) {
	        return _text2.default.FORMS.invalidEmailAddress;
	      } else if (!_this.newFormValid()) {
	        return 'Please provide at least the items name and type';
	      }
	    };
	
	    _extends(_this.state, {
	      stage: _this.state.stage || 1
	    });
	    return _this;
	  }
	
	  NewItemForm.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _overlayWrapper2.default,
	      {
	        title: _text2.default.CONTRIBUTION_FORMS.NEW_ITEM.title,
	        subTitle: _text2.default.CONTRIBUTION_FORMS.NEW_ITEM.subTitle,
	        footerProps: this.getFooterProps(null, !this.newFormValid(), this.newFormValidationMessage()),
	        stages: [{
	          name: 'Description',
	          active: this.state.stage === 1,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 1 });
	          }
	        }, {
	          name: 'Details',
	          active: this.state.stage === 2,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 2 });
	          }
	        }, {
	          name: 'Images',
	          active: this.state.stage === 3,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 3 });
	          }
	        }, {
	          name: 'Related',
	          active: this.state.stage === 4,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 4 });
	          }
	        }, {
	          name: 'Finish',
	          active: this.state.stage === 5,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 5 });
	          }
	        }]
	      },
	      _react2.default.createElement(
	        _formWrapper2.default,
	        { nested: true },
	        _react2.default.createElement(formStages[this.state.stage], {
	          // Stage One values
	          itemNameValue: this.state.itemNameValue,
	          setItemNameValue: this.setItemNameValue,
	          itemTypeValue: this.state.itemTypeValue,
	          setItemTypeValue: this.setItemTypeValue,
	          itemDescValue: this.state.itemDescValue,
	          setItemDescValue: this.setItemDescValue,
	
	          // Stage Two values
	          locationValue: this.state.locationValue,
	          setLocationValue: this.setLocationValue,
	          yearValue: this.state.yearValue,
	          setYearValue: this.setYearValue,
	          productionMethodValue: this.state.productionMethodValue,
	          setProductionMethodValue: this.setProductionMethodValue,
	          productionLocationValue: this.state.productionLocationValue,
	          setProductionLocationValue: this.setProductionLocationValue,
	          tablewareTypeValue: this.state.tablewareTypeValue,
	          setTablewareTypeValue: this.setTablewareTypeValue,
	          patternNumberValue: this.state.patternNumberValue,
	          setPatternNumberValue: this.setPatternNumberValue,
	          colorValue: this.state.colorValue,
	          setColorValue: this.setColorValue,
	          designerValue: this.state.designerValue,
	          setDesignerValue: this.setDesignerValue,
	
	          // Stage Three values
	          images: this.state.images,
	          setImages: this.handleSetImages,
	          mainImageValue: this.state.mainImageValue,
	          setMainImageValue: this.setMainImageValue,
	
	          // Stage Four values
	          relatedItems: this.state.relatedItems,
	          setRelatedItems: this.setRelatedItems,
	
	          // Stage Five
	          emailValue: this.state.emailValue,
	          setEmailValue: this.setEmailValue,
	          formValid: this.newFormValid(),
	          validationMessage: this.newFormValidationMessage()
	        })
	      )
	    );
	  };
	
	  return NewItemForm;
	}(_formController2.default);
	
	exports.default = NewItemForm;
	module.exports = exports['default'];

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	var _textArea = __webpack_require__(27);
	
	var _textArea2 = _interopRequireDefault(_textArea);
	
	var _dropDown = __webpack_require__(26);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var itemNameValue = _ref.itemNameValue,
	      setItemNameValue = _ref.setItemNameValue,
	      itemTypeValue = _ref.itemTypeValue,
	      setItemTypeValue = _ref.setItemTypeValue,
	      itemDescValue = _ref.itemDescValue,
	      setItemDescValue = _ref.setItemDescValue;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_textBox2.default, {
	      required: true,
	      id: _text2.default.FORMS.itemNameId,
	      label: _text2.default.FORMS.itemNameLabel,
	      placeholder: _text2.default.FORMS.itemNamePlaceholder,
	      value: itemNameValue,
	      onChange: setItemNameValue
	    }),
	    _react2.default.createElement(_dropDown2.default, {
	      required: true,
	      id: _text2.default.FORMS.itemTypeId,
	      label: _text2.default.FORMS.itemTypeLabel,
	      selectedValue: itemTypeValue,
	      onChange: setItemTypeValue,
	      options: [{ text: _text2.default.FORMS.itemTypePlaceholder, value: '' }, { text: 'Tableware Glass', value: 'TABLEWARE' }, { text: 'Stained Glass Window', value: 'WINDOW' }]
	    }),
	    _react2.default.createElement(_textArea2.default, {
	      id: _text2.default.FORMS.itemDescId,
	      label: _text2.default.FORMS.itemDescLabel,
	      placeholder: _text2.default.FORMS.itemDescPlaceholder,
	      value: itemDescValue,
	      onChange: setItemDescValue
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	var _dropDown = __webpack_require__(26);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _errorMessage = __webpack_require__(17);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var itemTypeValue = _ref.itemTypeValue,
	      setItemTypeValue = _ref.setItemTypeValue,
	      locationValue = _ref.locationValue,
	      setLocationValue = _ref.setLocationValue,
	      yearValue = _ref.yearValue,
	      setYearValue = _ref.setYearValue,
	      designerValue = _ref.designerValue,
	      setDesignerValue = _ref.setDesignerValue,
	      productionMethodValue = _ref.productionMethodValue,
	      setProductionMethodValue = _ref.setProductionMethodValue,
	      productionLocationValue = _ref.productionLocationValue,
	      setProductionLocationValue = _ref.setProductionLocationValue,
	      tablewareTypeValue = _ref.tablewareTypeValue,
	      setTablewareTypeValue = _ref.setTablewareTypeValue,
	      patternNumberValue = _ref.patternNumberValue,
	      setPatternNumberValue = _ref.setPatternNumberValue,
	      colorValue = _ref.colorValue,
	      setColorValue = _ref.setColorValue;
	  return _react2.default.createElement(
	    'div',
	    null,
	    !itemTypeValue && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_errorMessage2.default, { message: 'You must select the item\'s type before being able to enter it\'s details.' }),
	      _react2.default.createElement(_dropDown2.default, {
	        required: true,
	        id: _text2.default.FORMS.itemTypeId,
	        label: _text2.default.FORMS.itemTypeLabel,
	        selectedValue: itemTypeValue,
	        onChange: setItemTypeValue,
	        options: [{ text: _text2.default.FORMS.itemTypePlaceholder, value: '' }, { text: 'Tableware Glass', value: 'TABLEWARE' }, { text: 'Stained Glass Window', value: 'WINDOW' }]
	      })
	    ),
	    itemTypeValue === 'WINDOW' && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.locationId,
	        label: _text2.default.FORMS.locationLabel,
	        placeholder: _text2.default.FORMS.locationPlaceholder,
	        value: locationValue,
	        onChange: setLocationValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.yearId,
	        label: _text2.default.FORMS.yearLabel,
	        placeholder: _text2.default.FORMS.yearPlaceholder,
	        value: yearValue,
	        onChange: setYearValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.designerId,
	        label: _text2.default.FORMS.designerLabel,
	        placeholder: _text2.default.FORMS.designerPlaceholder,
	        value: designerValue,
	        onChange: setDesignerValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionMethodId,
	        label: _text2.default.FORMS.productionMethodLabel,
	        options: _text2.default.FORMS.productionMethodWindowOptions,
	        value: productionMethodValue,
	        onChange: setProductionMethodValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionLocationId,
	        label: _text2.default.FORMS.productionLocationLabel,
	        options: _text2.default.FORMS.productionLocationOptions,
	        value: productionLocationValue,
	        onChange: setProductionLocationValue
	      })
	    ),
	    itemTypeValue === 'TABLEWARE' && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.tablewareTypeId,
	        label: _text2.default.FORMS.tablewareTypeLabel,
	        placeholder: _text2.default.FORMS.tablewareTypePlaceholder,
	        value: tablewareTypeValue,
	        onChange: setTablewareTypeValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionMethodId,
	        label: _text2.default.FORMS.productionMethodLabel,
	        options: _text2.default.FORMS.productionMethodTablewareOptions,
	        value: productionMethodValue,
	        onChange: setProductionMethodValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.patternNumberId,
	        label: _text2.default.FORMS.patternNumberLabel,
	        placeholder: _text2.default.FORMS.patternNumberPlaceholder,
	        value: patternNumberValue,
	        onChange: setPatternNumberValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.colorId,
	        label: _text2.default.FORMS.colorLabel,
	        placeholder: _text2.default.FORMS.colorPlaceholder,
	        value: colorValue,
	        onChange: setColorValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.designerId,
	        label: _text2.default.FORMS.designerLabel,
	        placeholder: _text2.default.FORMS.designerPlaceholder,
	        value: designerValue,
	        onChange: setDesignerValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.yearId,
	        label: _text2.default.FORMS.yearLabel,
	        placeholder: _text2.default.FORMS.yearPlaceholder,
	        value: yearValue,
	        onChange: setYearValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionLocationId,
	        label: _text2.default.FORMS.productionLocationLabel,
	        options: _text2.default.FORMS.productionLocationOptions,
	        value: productionLocationValue,
	        onChange: setProductionLocationValue
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imageSelection = __webpack_require__(40);
	
	var _imageSelection2 = _interopRequireDefault(_imageSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var images = _ref.images,
	      setImages = _ref.setImages,
	      mainImageValue = _ref.mainImageValue,
	      setMainImageValue = _ref.setMainImageValue;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_imageSelection2.default, {
	      images: images,
	      onChange: setImages,
	      requiresMain: true,
	      setMainImageValue: setMainImageValue,
	      mainImageValue: mainImageValue
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _relatedItemsSelection = __webpack_require__(41);
	
	var _relatedItemsSelection2 = _interopRequireDefault(_relatedItemsSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var relatedItems = _ref.relatedItems,
	      setRelatedItems = _ref.setRelatedItems;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_relatedItemsSelection2.default, {
	      selectedItems: relatedItems,
	      onChange: setRelatedItems
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _emailInput = __webpack_require__(20);
	
	var _emailInput2 = _interopRequireDefault(_emailInput);
	
	var _errorMessage = __webpack_require__(17);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var emailValue = _ref.emailValue,
	      setEmailValue = _ref.setEmailValue,
	      formValid = _ref.formValid,
	      validationMessage = _ref.validationMessage;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_emailInput2.default, { emailValue: emailValue, setEmailValue: setEmailValue }),
	    !formValid && _react2.default.createElement(_errorMessage2.default, {
	      title: 'Form not complete for submission',
	      message: validationMessage
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(144);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _subHeading = __webpack_require__(48);
	
	var _subHeading2 = _interopRequireDefault(_subHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var setForm = _ref.setForm,
	      closeForm = _ref.closeForm;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(_subHeading2.default, { text: 'Select a method' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'How would you like to contribute?'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.twoButtons },
	      _react2.default.createElement(_pillButton2.default, {
	        theme: 'blue',
	        text: 'Edit details',
	        onClick: function onClick() {
	          return setForm('editItem');
	        }
	      }),
	      _react2.default.createElement(_pillButton2.default, {
	        theme: 'blue',
	        text: 'Upload images',
	        onClick: function onClick() {
	          return setForm('images');
	        }
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.twoButtons },
	      _react2.default.createElement(_pillButton2.default, {
	        theme: 'blue',
	        text: 'Submit details',
	        onClick: function onClick() {
	          return setForm('general');
	        }
	      }),
	      _react2.default.createElement(_pillButton2.default, {
	        theme: 'blue',
	        text: 'Add a memory',
	        onClick: function onClick() {
	          return setForm('memory');
	        }
	      })
	    ),
	    _react2.default.createElement(_pillButton2.default, { theme: 'grey-ghost', text: 'Cancel', onClick: closeForm })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-forms-select-form----styles-module---container---3sSLZ","twoButtons":"src-components-contribution-form-forms-select-form----styles-module---twoButtons---1tJV7"};

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _forms;
	
	// Starting point
	
	
	// Specific forms
	
	
	// Submitting states
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(151);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stylesModule = __webpack_require__(148);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _selectForm = __webpack_require__(117);
	
	var _selectForm2 = _interopRequireDefault(_selectForm);
	
	var _generalForm = __webpack_require__(108);
	
	var _generalForm2 = _interopRequireDefault(_generalForm);
	
	var _imageForm = __webpack_require__(109);
	
	var _imageForm2 = _interopRequireDefault(_imageForm);
	
	var _memoryForm = __webpack_require__(110);
	
	var _memoryForm2 = _interopRequireDefault(_memoryForm);
	
	var _newItemForm = __webpack_require__(111);
	
	var _newItemForm2 = _interopRequireDefault(_newItemForm);
	
	var _editItemForm = __webpack_require__(102);
	
	var _editItemForm2 = _interopRequireDefault(_editItemForm);
	
	var _submissionRequestHandler = __webpack_require__(161);
	
	var _submissionRequestHandler2 = _interopRequireDefault(_submissionRequestHandler);
	
	var _submitting = __webpack_require__(121);
	
	var _submitting2 = _interopRequireDefault(_submitting);
	
	var _submissionSuccessful = __webpack_require__(120);
	
	var _submissionSuccessful2 = _interopRequireDefault(_submissionSuccessful);
	
	var _submissionFailed = __webpack_require__(119);
	
	var _submissionFailed2 = _interopRequireDefault(_submissionFailed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var freezeBodyScroll = function freezeBodyScroll(addClass) {
	  return addClass ? setTimeout(function () {
	    return document.getElementById('wf-content').classList.add('content-hide');
	  }, 250) : document.getElementById('wf-content').classList.remove('content-hide');
	};
	
	var forms = (_forms = {}, _forms[null] = _selectForm2.default, _forms.general = _generalForm2.default, _forms.memory = _memoryForm2.default, _forms.images = _imageForm2.default, _forms.newItem = _newItemForm2.default, _forms.editItem = _editItemForm2.default, _forms);
	
	var a = function a(action, label) {
	  return ga('send', {
	    hitType: 'event',
	    eventCategory: 'ContributionForm',
	    eventAction: action,
	    eventLabel: label
	  });
	};
	
	var ContributionForm = function (_Component) {
	  _inherits(ContributionForm, _Component);
	
	  function ContributionForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContributionForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      form: null,
	      open: false,
	
	      submitting: false,
	      formData: null,
	      recoveryState: null,
	
	      submitted: false,
	      submissionSuccessful: null,
	      errorCode: null
	    }, _this.setForm = function (form) {
	      a('SelectForm', form);
	      _this.setState({ form: form });
	    }, _this.clearForm = function (form) {
	      return _this.setState({
	        form: null,
	        formData: null,
	        recoveryState: null
	      });
	    }, _this.closeForm = function () {
	      freezeBodyScroll(false);
	      _this.setState({ open: false });
	      setTimeout(_this.props.closeForm, 250);
	    }, _this.submitForm = function (formData, recoveryState) {
	      a('SubmitForm', _this.state.form);
	      _this.setState({
	        submitting: true,
	        formData: formData,
	        recoveryState: recoveryState
	      });
	
	      (0, _submissionRequestHandler2.default)(_this.state.form, _this.props.itemId, formData).then(function (result) {
	        if (result === true) {
	          a('SubmissionSuccessful', _this.state.form);
	        } else if (result && result.errorCode === 'REQUEST_TOO_LARGE') {
	          a('SubmissionFailed-RequestTooLarge', _this.state.form);
	        } else {
	          a('SubmissionFailed-GenericError', _this.state.form);
	        }
	
	        _this.setState({
	          submitting: false,
	          submitted: true,
	          submissionSuccessful: result === true,
	          errorCode: result === true ? null : result.errorCode || 'GENERIC_ERROR'
	        });
	      });
	    }, _this.backToForm = function () {
	      a('BackToInput', _this.state.form);
	      _this.setState({
	        submitted: false,
	        submissionSuccessful: null,
	        errorCode: null
	      });
	    }, _this.retrySubmission = function () {
	      a('RetrySubmission', _this.state.form);
	      _this.submitForm(_this.state.formData, _this.state.recoveryState);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ContributionForm.prototype.componentWillMount = function componentWillMount() {
	    a('OpenForm', this.props.form);
	    this.setState({ form: this.props.form });
	    freezeBodyScroll(true);
	  };
	
	  ContributionForm.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      return _this2.setState({ open: true });
	    }, 0);
	  };
	
	  ContributionForm.prototype.componentWillUnmount = function componentWillUnmount() {
	    a('CloseForm', this.state.form);
	    freezeBodyScroll(false);
	  };
	
	  ContributionForm.prototype.render = function render() {
	    return _reactDom2.default.createPortal(this.renderForm(), document.getElementById('wf-modals'));
	  };
	
	  ContributionForm.prototype.renderForm = function renderForm() {
	    var _this3 = this;
	
	    var _state = this.state,
	        submitting = _state.submitting,
	        submitted = _state.submitted,
	        submissionSuccessful = _state.submissionSuccessful,
	        errorCode = _state.errorCode;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_stylesModule2.default.container, this.state.open && _stylesModule2.default.isOpen)
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.scrollContainer },
	        function () {
	          if (submitting) {
	            return _react2.default.createElement(_submitting2.default, null);
	          } else if (submitted && submissionSuccessful) {
	            return _react2.default.createElement(_submissionSuccessful2.default, { closeForm: _this3.closeForm });
	          } else if (submitted && !submissionSuccessful) {
	            return _react2.default.createElement(_submissionFailed2.default, {
	              errorCode: errorCode,
	              backToForm: _this3.backToForm,
	              retrySubmission: _this3.retrySubmission
	            });
	          } else {
	            return _react2.default.createElement(forms[_this3.state.form], {
	              form: _this3.state.form,
	              setForm: _this3.setForm,
	              submitForm: _this3.submitForm,
	              clearForm: _this3.clearForm,
	              closeForm: _this3.closeForm,
	              secondaryButtonIsBack: !_this3.props.form,
	              recoveryState: _this3.state.recoveryState,
	              itemId: _this3.props.itemId
	            });
	          }
	        }()
	      )
	    );
	  };
	
	  return ContributionForm;
	}(_react.Component);
	
	exports.default = ContributionForm;
	module.exports = exports['default'];

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(145);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _Cross = __webpack_require__(28);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ERROR_MESSAGES = {
	  OFFLINE: _react2.default.createElement(
	    'p',
	    null,
	    'It looks like you are currently offline. Please reconnect and try again.'
	  ),
	  GENERIC_ERROR: _react2.default.createElement(
	    'p',
	    null,
	    'There may be an issue with our system. Please try again later.'
	  ),
	  REQUEST_TOO_LARGE: _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'The size of your uploads is too large for us to process.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Unfortunately for technical reasons we can only accept submissions of up to 6MB in size. If you have any images that are larger than 6MB individually please reduce their file size before submitting them. If you have multiple images please try sending several submissions so that each submission is\xA0less\xA0than\xA06MB.'
	    )
	  )
	};
	
	exports.default = function (_ref) {
	  var _ref$errorCode = _ref.errorCode,
	      errorCode = _ref$errorCode === undefined ? 'GENERIC_ERROR' : _ref$errorCode,
	      backToForm = _ref.backToForm,
	      retrySubmission = _ref.retrySubmission;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(_Cross2.default, { size: 96, color: '#AD343E' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Failed to send submission'
	    ),
	    navigator.onLine ? ERROR_MESSAGES[errorCode] : ERROR_MESSAGES.OFFLINE,
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.buttons },
	      _react2.default.createElement(_pillButton2.default, { theme: 'grey-ghost', text: 'Back', onClick: backToForm }),
	      (!navigator.onLine || errorCode !== 'REQUEST_TOO_LARGE') && _react2.default.createElement(_pillButton2.default, { theme: 'blue', text: 'Retry', onClick: retrySubmission })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-state-pages-submission-failed----styles-module---container---3_QKD","buttons":"src-components-contribution-form-state-pages-submission-failed----styles-module---buttons---wBCFv"};

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(146);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _Tick = __webpack_require__(62);
	
	var _Tick2 = _interopRequireDefault(_Tick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var closeForm = _ref.closeForm;
	  return _react2.default.createElement(
	    'div',
	    { id: 'form-submission-successful', className: _stylesModule2.default.container },
	    _react2.default.createElement(_Tick2.default, { size: 96, color: '#56ad65' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Your submission was successful'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We will need to review your submission before it can be published to the site.'
	    ),
	    _react2.default.createElement(_pillButton2.default, { theme: 'blue', text: 'Finish', onClick: closeForm })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-state-pages-submission-successful----styles-module---container---23fum"};

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(147);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _loadingIndicator = __webpack_require__(162);
	
	var _loadingIndicator2 = _interopRequireDefault(_loadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var closeForm = _ref.closeForm,
	      secondaryButtonIsBack = _ref.secondaryButtonIsBack,
	      clearForm = _ref.clearForm;
	  return _react2.default.createElement(
	    'div',
	    { id: 'form-submitting', className: _stylesModule2.default.container },
	    _react2.default.createElement(_loadingIndicator2.default, null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Sending your submission'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Please wait...'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-state-pages-submitting----styles-module---container---2Ldjy"};

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form----styles-module---container---1R3bm","isOpen":"src-components-contribution-form----styles-module---isOpen---3Cqlw","scrollContainer":"src-components-contribution-form----styles-module---scrollContainer---scAI5"};

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _stylesModule = __webpack_require__(236);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _backgroundContainer = __webpack_require__(33);
	
	var _backgroundContainer2 = _interopRequireDefault(_backgroundContainer);
	
	var _Arrow = __webpack_require__(125);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var id = _ref.id,
	      to = _ref.to,
	      onClick = _ref.onClick,
	      imageSrc = _ref.imageSrc,
	      title = _ref.title,
	      text = _ref.text;
	
	  var Tag = onClick ? 'button' : _gatsbyLink2.default;
	
	  return _react2.default.createElement(
	    Tag,
	    { id: id, to: to, onClick: onClick, className: _stylesModule2.default.container },
	    _react2.default.createElement(
	      _backgroundContainer2.default,
	      { src: imageSrc },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.inner },
	        _react2.default.createElement(
	          'p',
	          { className: _stylesModule2.default.title },
	          title
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _stylesModule2.default.text },
	          text
	        )
	      ),
	      _react2.default.createElement(_Arrow2.default, { color: '#fff', size: 32, direction: 'right' })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-tile-link----styles-module---container---2zIhH","inner":"src-components-tile-link----styles-module---inner---b5KNA","title":"src-components-tile-link----styles-module---title---1Q3h0","text":"src-components-tile-link----styles-module---text---2RkiM"};

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === undefined ? 16 : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$direction = _ref.direction,
	      direction = _ref$direction === undefined ? 'right' : _ref$direction;
	  return _react2.default.createElement(
	    'svg',
	    {
	      height: size,
	      width: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 24 24'
	    },
	    _react2.default.createElement('path', {
	      style: direction === 'left' ? { transformOrigin: '50% 50%', transform: 'rotate(180deg)' } : null,
	      fill: color,
	      d: 'M22 12l-4-4v3H3v2h15v3z'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === undefined ? 16 : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	  return _react2.default.createElement(
	    'svg',
	    {
	      height: size,
	      width: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 1024 1024'
	    },
	    _react2.default.createElement('path', {
	      style: {
	        transform: 'scale(0.75) rotate(45deg)',
	        transformOrigin: 'center'
	      },
	      fill: color,
	      d: 'M960.001 0q27.5 0 45.75 18.251t18.251 45.75q0 27-18.5 45.5l-403.001 402.5 403.001 402.5q18.5 18.5 18.5 45.5 0 27.5-18.251 45.75t-45.75 18.251q-27 0-45.5-18.5l-402.5-403.001-402.5 403.001q-18.5 18.5-45.5 18.5-27.5 0-45.75-18.251t-18.251-45.75q0-27 18.5-45.5l403.001-402.5-403.001-402.5q-18.5-18.5-18.5-45.5 0-27.5 18.251-45.75t45.75-18.251q27 0 45.5 18.5l402.5 403.001 402.5-403.001q18.5-18.5 45.5-18.5z'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === undefined ? 16 : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	  return _react2.default.createElement(
	    'svg',
	    {
	      height: size,
	      width: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 24 24'
	    },
	    _react2.default.createElement('path', {
	      fill: color,
	      d: 'M13 13h-2V7h2m0 10h-2v-2h2M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2z'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(32);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stylesModule = __webpack_require__(643);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _backgroundImage = __webpack_require__(100);
	
	var _backgroundImage2 = _interopRequireDefault(_backgroundImage);
	
	var _gridWrap = __webpack_require__(34);
	
	var _gridWrap2 = _interopRequireDefault(_gridWrap);
	
	var _gridRow = __webpack_require__(84);
	
	var _gridRow2 = _interopRequireDefault(_gridRow);
	
	var _gridCol = __webpack_require__(122);
	
	var _gridCol2 = _interopRequireDefault(_gridCol);
	
	var _tileLink = __webpack_require__(189);
	
	var _tileLink2 = _interopRequireDefault(_tileLink);
	
	var _subHeading = __webpack_require__(48);
	
	var _subHeading2 = _interopRequireDefault(_subHeading);
	
	var _contributionForm = __webpack_require__(118);
	
	var _contributionForm2 = _interopRequireDefault(_contributionForm);
	
	var _siteFooter = __webpack_require__(42);
	
	var _siteFooter2 = _interopRequireDefault(_siteFooter);
	
	var _room = __webpack_require__(46);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _tileOne = __webpack_require__(70);
	
	var _tileOne2 = _interopRequireDefault(_tileOne);
	
	var _tileTwo = __webpack_require__(71);
	
	var _tileTwo2 = _interopRequireDefault(_tileTwo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contribute = function (_Component) {
	  _inherits(Contribute, _Component);
	
	  function Contribute() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Contribute);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      contributingOpen: false,
	      contributingForm: null
	    }, _this.openContributing = function (view) {
	      return _this.setState({ contributingOpen: true, contributingForm: view });
	    }, _this.closeContributing = function (view) {
	      return _this.setState({ contributingOpen: false, contributingForm: null });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Contribute.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Contribute' }),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.container },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_backgroundImage2.default, { height: 540, src: _room2.default }),
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.top },
	            _react2.default.createElement(
	              _gridWrap2.default,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.topContent },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  'Contribute'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Sharing your knowledge of Whitefriars glass, or your memories of the Whitefriars Factory, will help to improve everyone\u2019s understanding of the Whitefriars they know, or have.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Here you can share your own knowledge and search for other similar pieces or windows, as well as read the memories of those who worked in the Factory.'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _gridWrap2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.content },
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.intro },
	              _react2.default.createElement(_subHeading2.default, { text: 'Find out how' }),
	              _react2.default.createElement(
	                'p',
	                null,
	                'All you need to do is select the type of entry you\u2019d like to make, and complete the form in as much detail as possible. The more you can fill out the better, but if you don\u2019t have access to part of the information don\u2019t worry. The more contributions we get the more complete picture we can build. If you can upload relevant, high quality images, then please upload them as PNG. or JPG. files.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Headstone Manor and Museum, is unable to offer valuations on any pieces and as such we have not included this as an available field in the contribution form. All submissions will be moderated before being added to the database.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Use the links below to get started on your contribution.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.linkSection },
	              _react2.default.createElement(
	                _gridRow2.default,
	                null,
	                _react2.default.createElement(
	                  _gridCol2.default,
	                  null,
	                  _react2.default.createElement(_subHeading2.default, { text: 'Get started' })
	                ),
	                _react2.default.createElement(
	                  _gridCol2.default,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.links },
	                    _react2.default.createElement(
	                      'div',
	                      { className: _stylesModule2.default.link },
	                      _react2.default.createElement(_tileLink2.default, {
	                        to: '/glass',
	                        imageSrc: _tileOne2.default,
	                        title: 'Existing Items',
	                        text: 'Check out the Whitefriars Glass we already have documented and see if you have anything to add.'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: _stylesModule2.default.link },
	                      _react2.default.createElement(_tileLink2.default, {
	                        id: 'open-new-item',
	                        onClick: function onClick() {
	                          return _this2.openContributing('newItem');
	                        },
	                        imageSrc: _tileTwo2.default,
	                        title: 'Add New Items',
	                        text: 'Add a new item of Whitefriars Glass that we don\'t yet have on the website.'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: _stylesModule2.default.link },
	                      _react2.default.createElement(_tileLink2.default, {
	                        onClick: function onClick() {
	                          return _this2.openContributing('memory');
	                        },
	                        imageSrc: _tileOne2.default,
	                        title: 'Add A Memory',
	                        text: 'Add one of your personal memories or stories related to Whitefriars or its products.'
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      this.state.contributingOpen && _react2.default.createElement(_contributionForm2.default, {
	        form: this.state.contributingForm,
	        closeForm: this.closeContributing
	      }),
	      _react2.default.createElement(_siteFooter2.default, null)
	    );
	  };
	
	  return Contribute;
	}(_react.Component);
	
	exports.default = Contribute;
	module.exports = exports['default'];

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-page-components-contribute----styles-module---container---3tucj","top":"src-page-components-contribute----styles-module---top---KMOQ0","topContent":"src-page-components-contribute----styles-module---topContent---3Cwz6","content":"src-page-components-contribute----styles-module---content---sYuFa","intro":"src-page-components-contribute----styles-module---intro---1wDoM","links":"src-page-components-contribute----styles-module---links---noZ7g","link":"src-page-components-contribute----styles-module---link---1zyFf"};

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _contribute = __webpack_require__(338);
	
	var _contribute2 = _interopRequireDefault(_contribute);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _contribute2.default;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contribute-js-0af72b5a9bec17b9396e.js